import { GalleryArtwork } from "kreate-common/modules/business-types";
import {
  DisplayableError,
  useDisplayableError,
} from "kreate-common/modules/displayable-error";
import {
  getResourceKey$GetGalleryArtwork,
  httpGet$GetGalleryArtwork,
} from "kreate-server/commands/GetGalleryArtwork/fetcher";
import { GetGalleryArtwork$Params } from "kreate-server/commands/GetGalleryArtwork/typing";
import useSWR from "swr";

export function useGalleryArtwork(
  params: GetGalleryArtwork$Params | undefined,
  { ignoreError }: { ignoreError: boolean }
): [
  data: GalleryArtwork | undefined,
  displayableError: DisplayableError | undefined
] {
  const { data, error } = useSWR(
    !params ? undefined : getResourceKey$GetGalleryArtwork(params),
    async () =>
      !params
        ? undefined
        : ignoreError
        ? await httpGet$GetGalleryArtwork("/api/v1/collector-gallery/artwork", {
            ...params,
            shouldReturnSecondaryCounting: true,
          }).catch()
        : await httpGet$GetGalleryArtwork("/api/v1/collector-gallery/artwork", {
            ...params,
            shouldReturnSecondaryCounting: true,
          })
  );
  const displayableError = useDisplayableError(ignoreError ? undefined : error);
  return [data, displayableError];
}
